import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { TextArea } from '../../../../../sharedComponents/TextArea';
import { InputField } from '../../../../../sharedComponents/InputField';
import { SharedSelect } from '../../../../../sharedComponents/SharedSelect';
import { SharedButton } from '../../../../../sharedComponents/Button';
import { useState } from 'react';
import { useEffect } from 'react';
import { business_location_update, get_business_location_detail } from '../../../../../Studio-Services/Studio_Services';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { AiFillMinusCircle } from 'react-icons/ai';
import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
import Swal from 'sweetalert2';
import logo from "../../../../../Images/logo_white_web.png"
import { useNavigate } from 'react-router-dom';

export default function Addroomform() {
  const navigate = useNavigate();

  const [list, setList] = useState();
  const business_id = localStorage.getItem('business_id');
  const [show, setShow] = useState();
  const [adr, setAdr] = useState();
  const [location_info, setLocation_info] = useState();

  const [state, setState] = useState({
    address: "",
    eAddress: ""
  })

  const [location, setLocation] = useState({
    is_address_same: 'No',
    address: ''
  });

  const handleAddressOtherChange = (event) => {
    setLocation({ ...location, address: event.target.value });
  };




  const getData = async () => {
    if (business_id) {
      const data = {
        business_id: business_id
      };
      const resp = await get_business_location_detail(data);
      if (resp) {
        setList(resp.data.data);
        setLocation_info(resp.data.data.location_info);
      }
    }
  };

  const options = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' },
  ];

  useEffect(() => {
    getData();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    // Perform form submission logic here
  };

  const addressHandler = (e) => {
    setAdr(e.target.value);

  }


  const handleChange = (address) => {
    setState({ address: address, eAddress: "", });
  };

  const handleSelect = async (address) => {
    setState({ address: address });
  };


  const handleAddRoom = () => {
    setLocation_info((prevLocationInfo) => [
      ...prevLocationInfo,
      {
        id: prevLocationInfo.length + 1,
        location_id: null,
        location_name: '',
        location_url: '',
        capacity: '',
        is_address_same: 'Yes',
        address: ''
      }
    ]);
  };

  const handleDeleteRoom = (index) => {
    setLocation_info((prevLocationArray) => {
      const updatedArray = [...prevLocationArray];
      updatedArray.splice(index, 1);
      return updatedArray;
    });
  };

  const showAddreess = (data) => {
    setShow(data);
  }



  const submitHandler = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    const location_id = formData.getAll("location_id[]");
    const location_name = formData.getAll("location_name[]");
    const is_address_same = formData.getAll("is_address_same[]");
    const address = formData.getAll("address[]");
    const capacity = formData.getAll("capacity[]");
    const location_url = formData.getAll("location_url[]");
    const country = formData.getAll("country[]");
    const state = formData.getAll("state[]");
    const city = formData.getAll("city[]");
    const lat = formData.getAll("lat[]");
    const longitude = formData.getAll("longitude[]");
    const zipcode = formData.getAll("zipcode[]");
    const id = formData.getAll("id[]");



    const location = [];

    for (let i = 0; i < location_info.length; i++) {
      if (location_id != null) {
        location.push({
          location_id: location_id[i],
          location_name: location_name[i],
          is_address_same: is_address_same[i],
          address: address[i],
          capacity: capacity[i],
          location_url: location_url[i],
          country: country[i],
          state: state[i],
          city: city[i],
          lat: lat[i],
          longitude: longitude[i],
          zipcode: zipcode[i]
        })
      } else {
        location.push({
          id: id[i],
          location_id: null,
          location_name: location_name[i],
          location_url: location_url[i],
          capacity: capacity[i],
          is_address_same: is_address_same[i],
          address: address[i]
        })
      }
    }

    const formValue = Object.fromEntries(formData.entries());

    const finalData = {
      user_id: formValue.user_id,
      business_id: formValue.business_id,
      business_address: formValue.business_address,
      location_info: location
    }

    const resp = await business_location_update(finalData);
    if (resp) {
      Swal.fire({
          html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
            <h4 class="title text-uppercase text-center mt-4 textWhite">
            SUCCESS
          </h4>
          <p class="text-center my-4 textcolor">
          <small class="textWhite">
          ${resp.data.message} </small></p>
          `,
          showClass: {
              popup: 'custom-dialog-container',
          },
          customClass: {
              confirmButton: 'custom-button custom-button-size modalbtn',
          },
      });
  }
  }

  
  return (
    <>
      <Form onSubmit={submitHandler}>
        <Row>
          <Col>
            <div className="RightSide">
              <h6>ROOMS FOR YOUR ACTIVITIES</h6>
              <InputField type="hidden" name="user_id" value={list && list.user_id ? list.user_id : ""} />
              <InputField type="hidden" name="business_id" value={list && list.business_id ? list.business_id : ""} />
              <InputField type="hidden" name="user_id[]" value={list && list.user_id ? list.user_id : ""} />
              <Row>
                <Col>
                  <div className="mb-3">
                    <label className="form-label inputLable">Head Quarters Address</label>
                    <textarea
                      className="form-control"
                      name='business_address'
                      rows="2"
                      readOnly
                      value={list ? list.address : ''}
                    />
                  </div>
                </Col>
              </Row>
              {location_info ? location_info.map((room, index) => (
                <>
                  <InputField type="hidden" name="location_id[]" value={room && room.location_id ? room.location_id : ""} />
                  <InputField type="hidden" name="id[]" value={room && room.id ? room.id : ""} />
                  <InputField type="hidden" name="country[]" value={room && room.country ? room.country : ""} />
                  <InputField type="hidden" name="state[]" value={room && room.state ? room.state : ""} />
                  <InputField type="hidden" name="state[]" value={room && room.state ? room.state : ""} />
                  <InputField type="hidden" name="city[]" value={room && room.city ? room.city : ""} />
                  <InputField type="hidden" name="lat[]" value={room && room.lat ? room.lat : ""} />
                  <InputField type="hidden" name="longitude[]" value={room && room.longitude ? room.longitude : ""} />
                  <InputField type="hidden" name="zipcode[]" value={room && room.zipcode ? room.zipcode : ""} />
                  <Row className="AddRoomRow" key={room.user_id}>
                    <Col>
                      <InputField lable="Room Name" name="location_name[]" value={room && room.location_name ? room.location_name : ""} placeholder="room name" type="text" required />
                    </Col>
                    <Col>
                      <InputField lable="Web Link" name="location_url[]" value={room && room.location_url ? room.location_url : ""} placeholder="" type="text" />
                    </Col>
                    <Col>
                      <InputField lable="Capacity" name="capacity[]" value={room && room.capacity ? room.capacity : ""} placeholder="0.00" type="number" required />
                    </Col>
                    <Col>
                      <SharedSelect lable="Address (Head Quarters)" name="is_address_same[]" onChange={(e) => { addressHandler(e); showAddreess(index) }} value={'Yes'} options={options} />
                    </Col>
                  </Row>
                  <Row>
                    {location_info.length != 1 && room.location_id === null ?
                      <Col><SharedButton className={"DeletedIcon"} iconNode={<AiFillMinusCircle />} onClick={() => handleDeleteRoom(index)} /></Col>
                      : ""}
                  </Row>
                  {adr === "No" && show === index ?
                    <Row>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="name">Address</label>
                          <PlacesAutocomplete
                            name="address[]"
                            value={state.address}

                            onChange={handleChange}
                            onSelect={handleSelect}
                          >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                              <div>
                                <input name="address" {...getInputProps({ placeholder: 'Search Places ...', className: ' form-control location-search-input', })} />
                                <span className="text-danger"><small>{state.eAddress ? state.eAddress : ""}</small></span>
                                <div className="autocomplete-dropdown-container m-0 position-absolute " style={{ zIndex: "2200", }}>
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion, i) => {

                                    const className = suggestion.active
                                      ? 'suggestion-item--active'
                                      : 'suggestion-item';
                                    // #fafafa
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                      ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                      : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                      <div key={i}
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </div>
                      </Col>
                      <Col></Col>
                    </Row>
                    : ""}
                </>
              ))
                : ""
              }

              <SharedButton onClick={handleAddRoom} iconNode={<BsFillPlusCircleFill />} className={"AddPlusIcon"} />
              <Row className='my-4'>
                <Col>
                  <SharedButton title={"Save & Continue"} type={"submit"} className={"btn btn-primary w-100"} />
                </Col>
                <Col>
                  <SharedButton title={"Done With Room"} type={"button"} onClick={()=>navigate('/add-items')} className={"btn btn-outline w-100"} />
                </Col>
                <Col></Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
}
